import { render, staticRenderFns } from "./update-contract.vue?vue&type=template&id=47fe3a6d"
import script from "./update-contract.vue?vue&type=script&lang=js"
export * from "./update-contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports